import {
  ArrowRight,
  Bolt,
  Check,
  Clock,
  DollarBill,
  Gift as GiftFill,
  Headset,
  Indicator,
  Lock as LockFill,
  Phone,
  Play,
  PlayCircle,
  Plus,
  PriceLock,
  Speedometer,
  Star as StarFill,
  Unlock,
  Users,
  Video,
  WholeHomeBundlePremium,
  Wifi,
} from '~/components/Icons/fill';
import {
  AllConnectLogo,
  Arrows,
  AutoPay,
  Ban,
  Bill,
  Box,
  Calendar,
  CheckCircle,
  CheckCircleBlack,
  CircleUp,
  Cloud,
  CloudData,
  Coin,
  CompareBill,
  ComparePlans,
  ConfirmationCheck,
  Close,
  CreditCard,
  DiagonalRight,
  Download,
  Edit,
  Email,
  Error,
  EveryDayLowPrice,
  EyeClosed,
  EyeOpen,
  Fiber,
  FrontierLogo,
  Gamepad,
  Gift,
  Gift2,
  GiftCard,
  Globe,
  HomeWifi,
  IdentityProtection,
  InfoCircle,
  Key,
  LaptopOpen,
  Lightning,
  LineChart,
  Lock,
  Locks,
  MagnifyingGlass,
  MapMarkerAlt,
  Money,
  Monitor,
  MultipleUsers,
  NetflixLogo,
  Notification,
  Offers,
  OfferBox,
  Pencil,
  PencilGrey,
  PhoneBlack,
  PhoneMirrored,
  PhoneVoice,
  PhoneWhite,
  PremiumTechSupport,
  Pricetag,
  PricetagWhite,
  Router,
  Search,
  SecureShield,
  Shield,
  ShieldCheckmark,
  ShieldIdentity,
  ShieldWifi,
  Snowflake,
  Spedometer,
  Star,
  Stopwatch,
  StopwatchRed,
  Ticket,
  TotalHomeWifi,
  Trash,
  TV,
  TvVas,
  UnbreakableWifi,
  UnlockOutline,
  Upload,
  UserAdd,
  Verified,
  VerizonFrontierLogo,
  VerizonLogo,
  Warning,
  WholeHomeWifi,
  WholeHomeWifiHouse,
  WifiBox,
  WifiBoxWhite,
  WifiLock,
  WifiSecurity,
  WifiSecurityPlus,
  Wrench,
  YouTube,
  YoutubePremium,
} from '~/components/Icons/outline';

export const iconMap = {
  'check-circle-outline': CheckCircle,
  'compare-bill': CompareBill,
  'dollar-bill': DollarBill,
  'magnifying-glass': MagnifyingGlass,
  'play-circle': PlayCircle,
  'play-icon': Play,
  GiftCard,
  giftCard: GiftCard,
  allConnectLogo: AllConnectLogo,
  arrowRight: ArrowRight,
  arrows: Arrows,
  autoPay: AutoPay,
  ban: Ban,
  bill: Bill,
  bolt: Bolt,
  box: Box,
  calendar: Calendar,
  check: Check,
  checkMark: Check,
  checkCircle: CheckCircle,
  checkCircleBlack: CheckCircleBlack,
  circleup: CircleUp,
  cloud: Cloud,
  cloudData: CloudData,
  coin: Coin,
  comparePlans: ComparePlans,
  confirmationCheck: ConfirmationCheck,
  clock: Clock,
  close: Close,
  creditCard: CreditCard,
  diagonalright: DiagonalRight,
  download: Download,
  edit: Edit,
  email: Email,
  error: Error,
  everyDayLowPrice: EveryDayLowPrice,
  eyeClosed: EyeClosed,
  eyeOpen: EyeOpen,
  fiber: Fiber,
  frontierLogo: FrontierLogo,
  gamepadOut: Gamepad,
  gift: Gift2,
  gift2Outline: Gift2,
  giftFill: GiftFill,
  giftOutline: Gift,
  globe: Globe,
  headset: Headset,
  homeWifi: HomeWifi,
  identityProtection: IdentityProtection,
  indicator: Indicator,
  infoCircle: InfoCircle,
  key: Key,
  laptopopen: LaptopOpen,
  lightning: Lightning,
  lineChart: LineChart,
  lock: LockFill,
  lockOutline: Lock,
  locks: Locks,
  mapMarkerAlt: MapMarkerAlt,
  multipleusers: MultipleUsers,
  money: Money,
  monitor: Monitor,
  multipleUsers: MultipleUsers,
  netflixLogo: NetflixLogo,
  notification: Notification,
  offers: Offers,
  offerBox: OfferBox,
  pencil: Pencil,
  pencilGrey: PencilGrey,
  phone: Phone,
  phoneBlack: PhoneBlack,
  phoneOutline: PhoneMirrored,
  phoneVoice: PhoneVoice,
  phoneWhite: PhoneWhite,
  plus: Plus,
  premiumTechSupport: PremiumTechSupport,
  priceLock: PriceLock,
  Pricetag: Pricetag,
  pricetagWhite: PricetagWhite,
  router: Router,
  search: Search,
  secureShield: SecureShield,
  shield: ShieldWifi,
  shieldCheckmark: ShieldCheckmark,
  shieldIdentity: ShieldIdentity,
  shieldOutline: Shield,
  snowflake: Snowflake,
  speedometer: Speedometer,
  speedometerOutline: Spedometer,
  star: StarFill,
  starFill: StarFill,
  starOutline: Star,
  stopwatch: Stopwatch,
  stopwatchRed: StopwatchRed,
  ticket: Ticket,
  totalHomeWifi: TotalHomeWifi,
  trash: Trash,
  tv: TV,
  tvVas: TvVas,
  unbreakableWifi: UnbreakableWifi,
  unlock: Unlock,
  unlockOutline: UnlockOutline,
  upload: Upload,
  userAdd: UserAdd,
  users: Users,
  verified: Verified,
  verizonFrontierLogo: VerizonFrontierLogo,
  verizonLogo: VerizonLogo,
  video: Video,
  warning: Warning,
  wholeHomeBundlePremium: WholeHomeBundlePremium,
  wholeHomeWifi: WholeHomeWifi,
  wholeHomeWifiHouseOutline: WholeHomeWifiHouse,
  wifi: Wifi,
  wifiBox: WifiBox,
  wifiBoxWhite: WifiBoxWhite,
  wifiLock: WifiLock,
  wifiSecurity: WifiSecurity,
  wifiSecurityPlus: WifiSecurityPlus,
  wrench: Wrench,
  youtube: YouTube,
  youtubePremium: YoutubePremium,
};

export const notificationsIconMap = {
  error: Error,
  success: CheckCircle,
  warning: InfoCircle,
};
